<template>
  <div class="base-section" :style="{ 'background-color': bgColor }">
    <div v-if="background" class="base-container" :style="{ 'background-image': 'url(' + background + ')' }" />
    <div v-if="background" class="base-container-overlay"/>
    <el-row type="flex" justify="center">
      <h1 class="title" :class="{ 'reverse': background }">{{ title }}</h1>
    </el-row>
    <el-row type="flex" justify="center">
      <h2 class="small-title" :class="{ 'reverse': background }" v-html="smallTitle"></h2>
    </el-row>
    <el-row type="flex" justify="center">
      <slot></slot>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Section',
  props: {
    title: {
      type: String,
      default: ''
    },
    smallTitle: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
  },
  data () {
    return {
      bgColor: this.backgroundColor
    }
  },
  mounted () {
    if (this.background) {
      this.bgColor = 'transparent'
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.base-section {
  position: relative;
  padding: 30px 15px;
  @media (min-width: 768px) {
   padding: 50px 25px;
  }
  & .base-container {
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }
  & .base-container-overlay {
    background-color: #000;
    opacity: 0.65;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 0;
  }

  & .title {
    font-size: 22px;
    font-family: 'AlteHaasGroteskBold', sans-serif;
    text-align: center;
  }
  & .reverse {
    color: #FFF;
  }
  & .small-title {
    font-size: 16px;
    font-weight: normal;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Section.vue